import { render } from "./EonForbiddenView.vue?vue&type=template&id=57e8730b&scoped=true"
import script from "./EonForbiddenView.vue?vue&type=script&lang=js"
export * from "./EonForbiddenView.vue?vue&type=script&lang=js"

import "./EonForbiddenView.vue?vue&type=style&index=0&id=57e8730b&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e8730b"]])

export default __exports__